import { makeStyles } from '@alpha/ui-lib/theme';

export const useStyles = makeStyles(
  () => ({
    link: {
      color: '#1E8777',
      fontWeight: 600,
    },
    bold: {
      fontWeight: 600,
    },
    tooltip: {
      backgroundColor: '#222222',
      color: '#FFFFFF',
      padding: '4px 8px',
      borderRadius: '4px',
      fontSize: '12px',
    },
  }),
  { name: 'MassDrawdownTable' },
);

export default useStyles;
